"use strict";

var _slicedToArray = require("D:\\RAPTIVITY_2020\\raptivity2020\\client\\node_modules\\@babel\\runtime/helpers/slicedToArray");

var _classCallCheck = require("D:\\RAPTIVITY_2020\\raptivity2020\\client\\node_modules\\@babel\\runtime/helpers/classCallCheck");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var variable_replacement_1 = require("../../utils/variable-replacement");

var user_agent_1 = require("../../utils/user-agent");

var cameras = require("../../../fixtures/regexes/device/cameras.json");

var CameraParser = function CameraParser() {
  _classCallCheck(this, CameraParser);

  this.parse = function (userAgent) {
    var result = {
      type: "",
      brand: "",
      model: ""
    };

    for (var _i = 0, _Object$entries = Object.entries(cameras); _i < _Object$entries.length; _i++) {
      var _ref3 = _Object$entries[_i];

      var _ref2 = _slicedToArray(_ref3, 2);

      var brand = _ref2[0];
      var camera = _ref2[1];
      var match = user_agent_1.userAgentParser(camera.regex, userAgent);
      if (!match) continue;
      result.type = "camera";
      result.brand = brand;

      if (camera.model) {
        result.model = variable_replacement_1.variableReplacement(camera.model, match).trim();
      } else if (camera.models) {
        var _iteratorNormalCompletion = true;
        var _didIteratorError = false;
        var _iteratorError = undefined;

        try {
          for (var _iterator = camera.models[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
            var model = _step.value;
            var modelMatch = user_agent_1.userAgentParser(model.regex, userAgent);
            if (!modelMatch) continue;
            result.model = variable_replacement_1.variableReplacement(model.model, modelMatch).trim();
            break;
          }
        } catch (err) {
          _didIteratorError = true;
          _iteratorError = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
              _iterator.return();
            }
          } finally {
            if (_didIteratorError) {
              throw _iteratorError;
            }
          }
        }
      }

      break;
    }

    return result;
  };
};

exports.default = CameraParser;